module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "plalism.24ac80f7.jpg";